import type { ReactNode } from "react";

/** Root layout — brand font stack (Work Sans, matches careers site). */
export function RootLayout({ children }: { children: ReactNode }) {
  return (
    <div style={{ fontFamily: "'Work Sans','Segoe UI',system-ui,sans-serif" }}>
      {children}
    </div>
  );
}
